import { Controller } from "@hotwired/stimulus"
import embed from "vega-embed"

export default class extends Controller {
  static targets = ["spec", "chart", "error"]

  connect() {
    this.renderChart()
  }

  async renderChart() {
    const specJson = this.hasSpecTarget ? this.specTarget.textContent.toString().trim() : ""
    if (!specJson) {
      this.showError("Chart spec was empty.")
      return
    }

    let spec
    try {
      spec = JSON.parse(specJson)
    } catch (_err) {
      this.showError("Chart spec could not be parsed.")
      return
    }

    try {
      await embed(this.chartTarget, spec, {
        actions: false,
        renderer: "svg"
      })
      this.hideError()
    } catch (_err) {
      this.showError("Chart failed to render.")
    }
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("d-none")
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.classList.add("d-none")
  }
}
